export const ADMIN = 'אדמין'
export const PERMISSIONS = 'הרשאות יעודיות'

export const ROLEKEYS = {
  ADMIN: 'ADMIN',
  PERMISSIONS: 'VIEWER',
}
export const PERMISSIONKEYS = {
  GAMES: 'MANAGE_GAMES',
  TEAMS: 'MANAGE_TEAMS',
  CHAMPIONS: 'CHAMPIONS_LEAGUE',
  CATEGORIES: 'SPORTS_CATEGORIES',
  USERS: 'MANAGE_USERS',
  RECORDS: 'RECORDS',
  LOGS: 'LOGS',
}

export const PERMISSIONLABELS = {
  MANAGE_USERS: 'משתמשים',
  SPORTS_CATEGORIES: 'ענפי ספורט',
  MANAGE_TEAMS: 'קבוצות',
  RECORDS: 'רשומות',
  LOGS: 'לוגים',
  MANAGE_GAMES: 'ניהול משחקים',
  CHAMPIONS_LEAGUE: 'ליגת האלופות',
}
